// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rolesmanagement_container_roles__h11Oq {
    display: flex;
    flex: 5 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: baseline;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    padding: 2rem;
}

.rolesmanagement_featuredItem__7-\\+Gn {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    cursor: default;
}

.rolesmanagement_featured__VqRNf {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.rolesmanagement_featuredTitleHeader__-97lc {
    color: var(--hsrcDarkBlue);
    font-size: 15px;
    font-weight: bold;
}

.rolesmanagement_sidebarSubListItem__7Ywym {
    padding-left: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    vertical-align: bottom;
    border-radius: 10px;
    margin-bottom: 25px;
}

.rolesmanagement_sidebarSubListItem__7Ywym.rolesmanagement_active__zvwpg,
.rolesmanagement_sidebarSubListItem__7Ywym:hover {
    /* background-color: rgb(240, 240, 255); */
}

.rolesmanagement_container_row__spPOO {
    display: flex;
    flex: 1 1;
    justify-content: space-between;
    flex-direction: column;
    align-content: center;
    align-items: center;
    align-self: center;
}

.rolesmanagement_printviewDialog__THINH {
    min-width: 90vw !important;
    max-width: 90vw !important;
}

.rolesmanagement_confirmDialogOverlay__U8nnD {
    z-index: 10000;
    pointer-events: none;
}

.rolesmanagement_logicalErrorsDialog__VKtuq {
    min-width: 35vw !important;
    max-width: 35vw !important;
    height: 90%;
}

.rolesmanagement_interactionDialog__Romge {
    min-width: 40vw !important;
    max-width: 40vw !important;
    height: 90%;
}

.rolesmanagement_interactionHistoryDialog__8S1jY {
    min-width: 60vw !important;
    max-width: 60vw !important;
    min-height: 85%;
    max-height: 90%;
}

.rolesmanagement_addRespondentDialog__mEJCW {
    min-width: 45vw !important;
    max-width: 45vw !important;
    min-height: 90%;
    max-height: 90%;
}

.rolesmanagement_editRespondentDialog__mxlFu {
    min-width: 45vw !important;
    max-width: 45vw !important;
    min-height: 90%;
    max-height: 90%;
}

.rolesmanagement_addRolesDialog__9-fvJ {
    min-width: 45vw !important;
    max-width: 45vw !important;
    min-height: 90%;
    max-height: 90%;
}

.rolesmanagement_editRolesDialog__Waygo {
    min-width: 45vw !important;
    max-width: 45vw !important;
    min-height: 90%;
    max-height: 90%;
    display: flexbox;
}

.rolesmanagement_flex_row_container__O6azo {
    display: inline-flexbox;
    flex-direction: row;
    flex: 11 1;
    width: 100%;
    align-items: flex-start;
    align-content: center;
    justify-content: left;
}

.rolesmanagement_widget_container__XKt45 {
    max-width: 40%;
    min-height: 40%;
    max-height: 50%;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/RolesManagement/rolesmanagement.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,SAAO;IACP,8BAA8B;IAC9B,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,UAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB","sourcesContent":[".container_roles {\r\n    display: flex;\r\n    flex: 5;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: baseline;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    padding: 2rem;\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    cursor: default;\r\n}\r\n\r\n.featured {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n}\r\n\r\n.sidebarSubListItem {\r\n    padding-left: 30px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    vertical-align: bottom;\r\n    border-radius: 10px;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.sidebarSubListItem.active,\r\n.sidebarSubListItem:hover {\r\n    /* background-color: rgb(240, 240, 255); */\r\n}\r\n\r\n.container_row {\r\n    display: flex;\r\n    flex: 1;\r\n    justify-content: space-between;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    align-items: center;\r\n    align-self: center;\r\n}\r\n\r\n.printviewDialog {\r\n    min-width: 90vw !important;\r\n    max-width: 90vw !important;\r\n}\r\n\r\n.confirmDialogOverlay {\r\n    z-index: 10000;\r\n    pointer-events: none;\r\n}\r\n\r\n.logicalErrorsDialog {\r\n    min-width: 35vw !important;\r\n    max-width: 35vw !important;\r\n    height: 90%;\r\n}\r\n\r\n.interactionDialog {\r\n    min-width: 40vw !important;\r\n    max-width: 40vw !important;\r\n    height: 90%;\r\n}\r\n\r\n.interactionHistoryDialog {\r\n    min-width: 60vw !important;\r\n    max-width: 60vw !important;\r\n    min-height: 85%;\r\n    max-height: 90%;\r\n}\r\n\r\n.addRespondentDialog {\r\n    min-width: 45vw !important;\r\n    max-width: 45vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n.editRespondentDialog {\r\n    min-width: 45vw !important;\r\n    max-width: 45vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n.addRolesDialog {\r\n    min-width: 45vw !important;\r\n    max-width: 45vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n.editRolesDialog {\r\n    min-width: 45vw !important;\r\n    max-width: 45vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n    display: flexbox;\r\n}\r\n\r\n.flex_row_container {\r\n    display: inline-flexbox;\r\n    flex-direction: row;\r\n    flex: 11;\r\n    width: 100%;\r\n    align-items: flex-start;\r\n    align-content: center;\r\n    justify-content: left;\r\n}\r\n\r\n.widget_container {\r\n    max-width: 40%;\r\n    min-height: 40%;\r\n    max-height: 50%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_roles": `rolesmanagement_container_roles__h11Oq`,
	"featuredItem": `rolesmanagement_featuredItem__7-+Gn`,
	"featured": `rolesmanagement_featured__VqRNf`,
	"featuredTitleHeader": `rolesmanagement_featuredTitleHeader__-97lc`,
	"sidebarSubListItem": `rolesmanagement_sidebarSubListItem__7Ywym`,
	"active": `rolesmanagement_active__zvwpg`,
	"container_row": `rolesmanagement_container_row__spPOO`,
	"printviewDialog": `rolesmanagement_printviewDialog__THINH`,
	"confirmDialogOverlay": `rolesmanagement_confirmDialogOverlay__U8nnD`,
	"logicalErrorsDialog": `rolesmanagement_logicalErrorsDialog__VKtuq`,
	"interactionDialog": `rolesmanagement_interactionDialog__Romge`,
	"interactionHistoryDialog": `rolesmanagement_interactionHistoryDialog__8S1jY`,
	"addRespondentDialog": `rolesmanagement_addRespondentDialog__mEJCW`,
	"editRespondentDialog": `rolesmanagement_editRespondentDialog__mxlFu`,
	"addRolesDialog": `rolesmanagement_addRolesDialog__9-fvJ`,
	"editRolesDialog": `rolesmanagement_editRolesDialog__Waygo`,
	"flex_row_container": `rolesmanagement_flex_row_container__O6azo`,
	"widget_container": `rolesmanagement_widget_container__XKt45`
};
export default ___CSS_LOADER_EXPORT___;
